import MRate from './Rate.vue';

export default MRate;
